import { useRoute } from "@/context/router";
import { Button, Text } from "@fluentui/react-components";
import { ChevronLeftFilled } from "@fluentui/react-icons";
import React from "react";
import { useClauseHeaderStyles } from "./styles";

export const ClauseHeader = ({ title }: { title: string }) => {
  const { setCurrentRoute } = useRoute();
  const styles = useClauseHeaderStyles();

  const onGoBack = () => {
    setCurrentRoute("revisions");
  };

  return (
    <div className={styles.header}>
      <Button size="small" onClick={onGoBack} shape="circular" icon={<ChevronLeftFilled />} />
      <Text>{title}</Text>
    </div>
  );
};
